"use client";
import BodylineText from "@/components/common/text/bodyline-text";
import HeadlineText from "@/components/common/text/headline-text";
import ScreenLayout from "@/components/layout/screen-layout";
import { AI_Tools_Marquee_Data } from "@/lib/dto/ai-engineering-squad/ai-tools-marquee-data";
import Image from "next/image";
import Marquee from "react-fast-marquee";

function AI_Tools_Marquee_Section() {
    return (
        <ScreenLayout outerClassName="mb-16 bg-white">
            <section className="">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12 lg:mb-16">
                        <HeadlineText
                            wrapperClassName="mb-6"
                            textClassName="text-gray-900"
                        >
                            {AI_Tools_Marquee_Data.title}
                        </HeadlineText>
                        <BodylineText
                            wrapperClassName="max-w-3xl mx-auto"
                            textClassName="text-gray-600"
                        >
                            {AI_Tools_Marquee_Data.subtitle}
                        </BodylineText>
                    </div>

                    <div className="overflow-hidden">
                        <Marquee
                            autoFill
                            gradient
                            gradientWidth={85}
                            pauseOnHover
                            speed={40}
                            className="w-full"
                        >
                            <div className="flex items-center mx-4 gap-8 md:gap-12">
                                {AI_Tools_Marquee_Data.tools.map((tool, index) => (
                                    <div key={index} className="flex items-center justify-center group">
                                        <div className="relative">
                                            {/* AI Tool Icon */}
                                            <div className="w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 rounded-2xl overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100 border border-gray-200 flex items-center justify-center transition-all duration-300">
                                                <Image
                                                    src={tool.icon}
                                                    alt={tool.alt}
                                                    width={48}
                                                    height={48}
                                                    className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 object-contain rounded-xl"
                                                />
                                            </div>

                                            {/* Glass Effect Banner with Name */}
                                            <div className="absolute inset-0 bg-white/80 backdrop-blur-sm rounded-2xl border border-white/20 opacity-0 group-hover:opacity-100 transition-all duration-300 flex items-center justify-center">
                                                <div className="text-center px-3">
                                                    <p className="text-sm md:text-base font-semibold text-gray-900">
                                                        {tool.name}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Marquee>
                    </div>
                </div>

            </section>

        </ScreenLayout>


    );
}

export default AI_Tools_Marquee_Section; 